// extracted by mini-css-extract-plugin
export default {"affair":"Affair_affair__-Ob71","name":"Affair_name__kJRaW","closeButton":"Affair_closeButton__S2IL7"};